import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ActionableItem from "../../models/actionable-item";

export default class ActionableItemsRepository extends BaseRepository {
  static modelClass = ActionableItem;
  modelName = 'actionable-item';
}